/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdDomainSettingsWebRuntimeType } from './FxIdDomainSettingsWebRuntimeType';
import {
    FxIdDomainSettingsWebRuntimeTypeFromJSON,
    FxIdDomainSettingsWebRuntimeTypeFromJSONTyped,
    FxIdDomainSettingsWebRuntimeTypeToJSON,
    FxIdDomainSettingsWebRuntimeTypeToJSONTyped,
} from './FxIdDomainSettingsWebRuntimeType';

/**
 * 
 * @export
 * @interface FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions
 */
export interface FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions {
    /**
     * 
     * @type {FxIdDomainSettingsWebRuntimeType}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions
     */
    Default: FxIdDomainSettingsWebRuntimeType;
    /**
     * 
     * @type {Array<FxIdDomainSettingsWebRuntimeType>}
     * @memberof FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions
     */
    Supported: Array<FxIdDomainSettingsWebRuntimeType>;
}



/**
 * Check if a given object implements the FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions interface.
 */
export function instanceOfFxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions(value: object): value is FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions {
    if (!('Default' in value) || value['Default'] === undefined) return false;
    if (!('Supported' in value) || value['Supported'] === undefined) return false;
    return true;
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions {
    if (json == null) {
        return json;
    }
    return {
        
        'Default': FxIdDomainSettingsWebRuntimeTypeFromJSON(json['Default']),
        'Supported': ((json['Supported'] as Array<any>).map(FxIdDomainSettingsWebRuntimeTypeFromJSON)),
    };
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSON(json: any): FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions {
    return FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSONTyped(json, false);
}

export function FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptionsToJSONTyped(value?: FxIdApplicationPublicDataBuilderPlatformDataOptionsWebOptionsWebRuntimesOptions | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Default': FxIdDomainSettingsWebRuntimeTypeToJSON(value['Default']),
        'Supported': ((value['Supported'] as Array<any>).map(FxIdDomainSettingsWebRuntimeTypeToJSON)),
    };
}

